import type { ReactNode } from 'react'

import { MemberRoleBadge } from './member-role-badge.atom'
import { MemberRoleSelect } from './member-role-select.molecule'
import type { OrganizationMember, OrganizationRoleKey } from './members.interface'

interface MemberRoleCellProps {
  member: OrganizationMember
  canManageMembers: boolean
  onRoleChange: (memberId: string, memberRole: OrganizationRoleKey) => void
}

export const MemberRoleCell: React.FC<MemberRoleCellProps> = ({
  member,
  canManageMembers,
  onRoleChange,
}): ReactNode => {
  if (!canManageMembers || member.isCurrentUser) {
    return <MemberRoleBadge memberRole={member.memberRole} />
  }

  const handleRoleChange = (memberRole: OrganizationRoleKey): void => {
    onRoleChange(member.id, memberRole)
  }

  return <MemberRoleSelect value={member.memberRole} onChange={handleRoleChange} />
}

MemberRoleCell.displayName = 'MemberRoleCell'
